<div class="modal-login">
  <div class="modal-dialog" role="document">
    <div class="modal-content" *ngIf="organization.name || !auth.isLoggedIn">
      <div class="modal-header border-bottom-0" style="padding: 2rem !important">
        <h5 *ngIf="organization.logo" class="modal-title text-center w-100">
          <img [src]="'https://app.assistonline.eu' + organization.logo"
               class="w-50"
               [alt]="'Logo van ' + organization.name" />
        </h5>

        <h5 *ngIf="!organization.logo" class="modal-title text-center w-100">
          <img src="../../assets/img/logo-mijnassist.png" class="w-75 mt-3" alt="Logo van Assist" />
        </h5>
      </div>

      <ng-container *ngIf="auth.isLoggedIn">
        <!-- Selectie: personen met hetzelfde e-mailadres, standaard aangevinkt, ter koppeling -->
        <div class="modal-body pt-0 pb-3" *ngIf="showSelection">
          <div class="text-center mb-4">
            <p>
              We vonden personen met jouw e-mailadres bij<br />
              <strong>{{ organization.name }}</strong>.<br />
              Vink aan wie je aan je MijnAssist-account wil koppelen.
            </p>
          </div>
          <div class="mb-3">
            <app-radio *ngFor="let c of matchCandidates"
                       type="checkbox"
                       [control]="c.control"
                       [label]="c.person.firstName + ' ' + c.person.lastName"></app-radio>
          </div>
          <div class="text-center">
            <app-button (click)="couple()"
                        buttonClass="btn btn-primary"
                        [iconClass]="'fa-link'"
                        [name]="'Koppelen'"
                        [isSaving]="isCoupling"
                        [disabled]="!hasSelection"></app-button>
          </div>
        </div>

        <!-- Gekoppelde personen kiezen (standaardflow) -->
        <div class="modal-body pt-0 pb-3" *ngIf="!showSelection">
          <div class="text-center mb-4">
            <div class="text-center">
              <p>
                Welkom in de MijnAssist-omgeving van<br />
                <strong>{{ organization.name }}</strong>.<br />
                Voor wie wil je gegevens in MijnAssist beheren?
              </p>
            </div>
          </div>
          <div class="text-center">
            <p *ngFor="let p of persons; index as i">
              <app-button (click)="loginAs(p)"
                          [iconClass]="'fa-arrow-right-to-bracket'"
                          [name]="p.person.firstName + ' ' + p.person.lastName"></app-button>
            </p>
            <p *ngIf="!isLoading && (!persons || persons.length==0)">Geen personen gekoppeld aan je MijnAssist-account.</p>
          </div>
        </div>
        <div class="modal-footer">
          <div class="text-center">
            <p class="pt-4">
              <a (click)="auth.logout()" style="text-decoration: underline">Afmelden</a>
            </p>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!auth.isLoggedIn">
        <div class="modal-body pt-2 pb-3">
          <div class="text-center mb-4">
            <h5>Aanmelden in MijnAssist</h5>
            <p>
              <b>MijnAssist</b> is de persoonlijke omgeving van leden en vrijwilligers van
              organisaties en lokale besturen die
              <a href="https://assistonline.eu/"
                 target="_blank"
                 style="outline: none; text-decoration: underline">Assist</a>
              gebruiken.
            </p>
            <p>
              Heb jij al een MijnAssist-account dan kan je hier aanmelden. Heb je nog geen
              MijnAssist-account, neem dan contact op met de organisatie waar je lid en/of
              vrijwilliger bent en vraag hen om je hiervoor uit te nodigen.
            </p>
          </div>
          <div class="text-center">
            <p *ngIf="auth.isAuthAvailable">
              <app-button (click)="auth.login()"
                          [iconClass]="'fa-arrow-right-to-bracket'"
                          [name]="'Aanmelden'"></app-button>
            </p>
            <p *ngIf="!auth.isAuthAvailable">
              <i class="fa-solid fa-circle-info me-2"></i>
              Aanmelden is momenteel niet beschikbaar. Probeer het later opnieuw.
            </p>
          </div>
        </div>
        <div class="modal-footer"></div>
      </ng-container>
    </div>
  </div>
</div>
